type MapPreferences = {
	enable_traffic_layer?: boolean;
	map_view?: boolean; // true for map view, false for satellite
};

const getMapPreferences = (localStorageKey?: string): MapPreferences | null => {
	if (!localStorageKey || typeof window === 'undefined' || !window.localStorage) {
		return null;
	}

	try {
		const stored = window.localStorage.getItem(localStorageKey);
		if (!stored) {
			return null;
		}
		return JSON.parse(stored) as MapPreferences;
	} catch (error) {
		console.warn(`Failed to parse localStorage for key "${localStorageKey}":`, error);
		return null;
	}
};

export const getTrafficLayerPreference = (localStorageKey?: string): boolean | null => {
	const preferences = getMapPreferences(localStorageKey);
	return preferences?.enable_traffic_layer ?? null;
};

export const getMapViewPreference = (localStorageKey?: string): boolean | null => {
	const preferences = getMapPreferences(localStorageKey);
	return preferences?.map_view ?? null;
};

export const setTrafficLayerPreference = (localStorageKey: string, enabled: boolean): void => {
	if (typeof window === 'undefined' || !window.localStorage) {
		return;
	}

	try {
		const existing = getMapPreferences(localStorageKey) || {};
		const updated = {
			...existing,
			enable_traffic_layer: enabled
		};
		window.localStorage.setItem(localStorageKey, JSON.stringify(updated));
	} catch (error) {
		console.warn(`Failed to save traffic layer preference to localStorage for key "${localStorageKey}":`, error);
	}
};

export const setMapViewPreference = (localStorageKey: string, isMapView: boolean): void => {
	if (typeof window === 'undefined' || !window.localStorage) {
		return;
	}

	try {
		const existing = getMapPreferences(localStorageKey) || {};
		const updated = {
			...existing,
			map_view: isMapView
		};
		window.localStorage.setItem(localStorageKey, JSON.stringify(updated));
	} catch (error) {
		console.warn(`Failed to save map view preference to localStorage for key "${localStorageKey}":`, error);
	}
};
